import { Theme } from '../../styles/theme';

const styles = (theme: Theme) => ({
  page: {
    minHeight: '100%',
    minWidth: '100%',
    backgroundColor: theme.palette.grey[50],
  },
});

export default styles;
